var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('div',{staticClass:"loadingscreen-cont"},[_c('img',{staticClass:"loadingscreen-img",attrs:{"src":_vm.qmkey_icon}}),_c('div',{staticClass:"loadingscreen-progress-cont"},[_c('v-progress-linear',{attrs:{"indeterminate":"","size":"64","color":"primary"}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }